import { mapGetters } from 'vuex';
import mvtCollapse from '@/common/components/mvtcollapse/mvt-collapse.vue';
import mvtInputDecimalNumber from '@/common/components/mvtinputdecimalnumber/mvt-inputdecimalnumber.vue';
import mvtInputNumber from '@/common/components/mvtinputnumber/mvt-inputnumber.vue';
import mvtTextbox from '@/common/components/mvttextbox/mvt-textbox.vue';

export default {
    name: 'mvtSaleProceeds',
    inject: ['$eventBus'],
    components: {
        mvtCollapse,
        mvtInputDecimalNumber,
        mvtInputNumber,
        mvtTextbox
    },
    data(){
        return {
            agentPercent: 6,
            agentFee: 0,
            closingPercent: 1.25,
            closingCosts: 0,
            homeprepPercent: 1,
            homePrepFee: 0,
            storagePercent: 1,
            storageFee: 0,
            concessionPercent: 0,
            concessionFee:0,
            mortgage: 0,
            price: this.salePrice,
        };
    },
    props: {
        salePrice: {
            type: Number,
            default: 400000,
        },
    },
    watch: {
        salePrice(newVal){
            this.price = newVal
            this.updateFeesBasedPerc()
        },
        netProceeds(newVal) {
            this.$emit('netProceeds', newVal);
        }
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),

        netClosingFee() {
            return this.agentFee + this.closingCosts + this.concessionFee
        },
        netMiscCosts() {
            return this.homePrepFee + this.storageFee
        },
        totalCosts() {
            return this.netClosingFee + this.netMiscCosts
        },
        netProceeds() {
            return this.getPrice - this.mortgage - this.totalCosts
        },
        getPrice() {
            return this.price
        }
    },
    mounted() {
        this.updateFeesBasedPerc()
    },
    methods: {
        updateFeesBasedPerc() {
            this.updateAgentFee()
            this.updateClosingCosts()
            this.updateHomePrepFee()
            this.updateStorageFee()
        },
        updateAgentPerc() {
            this.agentPercent = this.getPercentage(this.agentFee)
        },
        updateAgentFee() {
            this.agentFee = this.getFee(this.agentPercent)
        },

        updateClosingPerc() {
            this.closingPercent = this.getPercentage(this.closingCosts)
        },
        updateClosingCosts() {
            this.closingCosts = this.getFee(this.closingPercent)
        },

        updateConcessionPerc() {
            this.concessionPercent = this.getPercentage(this.concessionFee)
        },
        updateConcessionFee() {
            this.concessionFee = this.getFee(this.concessionPercent)
        },

        updateHomePrepPerc(){
            this.homeprepPercent = this.getPercentage(this.homePrepFee)
        },
        updateHomePrepFee() {
            this.homePrepFee =  this.getFee(this.homeprepPercent)
        },

        updateStoragePerc() {
            this.storagePercent =  this.getPercentage(this.storageFee)
        },
        updateStorageFee() {
            this.storageFee = this.getFee(this.storagePercent)
        },

        getPercentage(fee) {
            return (fee * 100) / this.getPrice
        },
        getFee(percentage) {
            return this.getPrice * (percentage / 100)
        },

        openLead() {
            let hotleadOpt = {
                hotleadType: 'HomeValueEstimate',
                hotleadSup: 'GET STARTED',
                buttonText: 'Connect Now',
                hotleadTitle: 'Connect with an experienced agent',
                showZipcode: true,
                hideProfile: true,
                noSellLead: true,
                hideVeteran: true,
            };
            this.$eventBus?.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: hotleadOpt
            });
        },

    }
};